import { Loading } from "@/app/components/LoadingFilters";

export const LoadingPagination = () => (
  <div className="flex justify-between items-center w-full">
    <Loading className="h-6 w-8" />
    <Loading className="h-6 w-16" />
    <Loading className="h-6 w-8" />
  </div>
);
